<template>
	<div class="auth-box-info">
		<!-- <navBar></navBar> -->
		<div class="auth-box">
			<authorized :authData="authData" />
		</div>
	</div>
</template>

<script>
	import http from "@/utils/axios";
	import navBar from '@/components/navBack'
	import bigBtn from './components/bigBtn'
	import authLogin from './components/authLogin'
	import authorized from './components/authorized'
	import './components/auth.less'
	export default {
		name: "index",
		components: {
			navBar,
			bigBtn,
			authLogin,
			authorized
		},
		data () {
			return {
				// isAuth: false,
				isShowLogin: false,
				authData: {},
				logoImg: require('../../assets/order/icon-logo.png')
			}
		},
		mounted () {
			this.getData();
		},
		methods: {
			onBtnClick () {
				this.isShowLogin = true
			},
			getData() {
				http({
					url: '/order/bees/bees/stock100/getAuthorizationInfo',
					method: 'post'
				})
				.then(rps=>{
					this.$loading.hide();
					if(rps.code == 200) {
						this.authData = rps.data;
						// this.isAuth = rps.data.isAuth;
					}
				})
			}
		}
	}
</script>
